import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface BankAccount {
  id: string;
  userId: string;
  provider: string;
  accountId: string;
  institutionId: number | null;
  type: string;
  name: string | null;
  balance: string;
  createdAt: string;
  updatedAt: string;
  property?: {
    id: string;
    address: string;
  } | null;
}

interface BankAccountState {
  accounts: BankAccount[];
  loading: boolean;
  error: string | null;
}

const initialState: BankAccountState = {
  accounts: [],
  loading: false,
  error: null,
};

const bankAccountSlice = createSlice({
  name: "bankAccounts",
  initialState,
  reducers: {
    fetchAccountsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchAccountsSuccess(state, action: PayloadAction<BankAccount[]>) {
      state.loading = false;
      state.accounts = action.payload;
    },
    fetchAccountsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchAccountsStart,
  fetchAccountsSuccess,
  fetchAccountsFailure,
} = bankAccountSlice.actions;

export default bankAccountSlice.reducer;
